import React, { useContext, useState } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from './AuthContext';

/**
 * "Continue with Google" — one button, used on both Login and Signup.
 *
 * There is no separate Google *signup* flow: the backend creates the account on first
 * sign-in, and links it to an existing account if the (Google-verified) email already
 * exists. So both pages want exactly this.
 *
 * Renders nothing if REACT_APP_GOOGLE_CLIENT_ID is unset, so the app still works in
 * environments where Google isn't configured rather than showing a button that fails.
 */
const GoogleSignInButton = ({ onError }) => {
  const { loginWithGoogle } = useContext(AuthContext);
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);

  const clientId = (process.env.REACT_APP_GOOGLE_CLIENT_ID || '').trim();
  if (!clientId) return null;

  const handleSuccess = async (credentialResponse) => {
    setBusy(true);
    try {
      // credentialResponse.credential is the Google ID token. The backend verifies it
      // against Google's public keys — we never trust it client-side.
      await loginWithGoogle(credentialResponse.credential);
      navigate('/dashboard');
    } catch (err) {
      console.error('Google sign-in failed:', err);
      if (onError) onError(err.message || 'Google sign-in failed. Please try again.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={{ marginTop: '1rem', textAlign: 'center' }}>
      <div style={{ margin: '0.75rem 0', color: '#888', fontSize: '0.85rem' }}>or</div>
      <div style={{ display: 'flex', justifyContent: 'center', opacity: busy ? 0.6 : 1 }}>
        <GoogleLogin
          onSuccess={handleSuccess}
          onError={() => {
            if (onError) onError('Google sign-in was cancelled or failed.');
          }}
          useOneTap={false}
        />
      </div>
    </div>
  );
};

export default GoogleSignInButton;
